import { Check } from "lucide-react";
import React from "react";
import { StepperProps } from "src/interfaces/functionalComponentInterface";

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  const steps = [
    { id: 1, label: "Start Date" },
    { id: 2, label: "Client Data" },
    { id: 3, label: "Results" },
  ];

  return (
    <div className="sticky w-full flex">
      {steps.map((step, index) => {
        let status = "Incomplete";
        if (currentStep > step.id) {
          status = "Completed";
        } else if (currentStep === step.id) {
          status = "Current";
        }

        return (
          <div
            key={step.id}
            className="w-full relative  flex flex-col justify-center items-center"
          >
            <div
              className={`w-7 h-7 flex items-center justify-center rounded-full mb-2 z-10 ${
                status === "Current"
                  ? "bg-tertiary text-white"
                  : status === "Completed"
                  ? "bg-secondary text-white"
                  : "bg-gray-200 text-gray-400"
              }`}
            >
              {status === "Current" && (
                <span className="w-3.5 h-3.5 bg-white rounded-full"></span>
              )}
              {status === "Completed" && <Check />}
            </div>

            <div className="text-center">
              <p className="font-semibold text-sm md:text-base ">
                {step.label}
              </p>
              <div>
                <p
                  className={`text-xs md:text-sm font-normal text-gray-400
                }`}
                >
                  {status}
                </p>
              </div>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`absolute h-[1px] w-[100%] left-[50%] top-3.5 line bg-gray-200 ${
                  currentStep > step.id ? "active" : ""
                }`}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default Stepper;
